export default __webpack_public_path__ + "static/media/thumbnail.15e5c071.webp";